export class ImageFilter {

  value: string;
  label: string;
  active: boolean;

  constructor() {}

}
